// extracted by mini-css-extract-plugin
export default {"Virtual":"Virtual_Virtual__cvpXY","left":"Virtual_left__PR598","wrapper":"Virtual_wrapper__meGnW"};